import { Button } from 'antd';
import Axios from 'axios';
import { loginUser } from '../../../_actions/user_actions';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { DivHorizental } from '../LandingPage/LandingPage';
import { BtnFullWidth } from '../LoginPage/LoginPage';

export const BtnFullWidthMargined = styled(BtnFullWidth)`
    * + & {
        margin-top: 10px;
    }
`;

function ForgotPasswordPage(props) {

    const dispatch = useDispatch();
    const state = props.location.state;
    const [Email, setEmail] = useState(state?.email);
    const [AuthNum, setAuthNum] = useState();
    const [minutes, setMinutes] = useState();
    const [seconds, setSeconds] = useState();

    useEffect(() => {
        const countdown = setInterval(() => {
            if (parseInt(seconds) > 0) {
                setSeconds(parseInt(seconds) - 1);
            }
            if (parseInt(seconds) === 0) {
                if (parseInt(minutes) === 0) {
                    clearInterval(countdown);
                } else {
                    setMinutes(parseInt(minutes) - 1);
                    setSeconds(59);
                }
            }
        }, 1000);
        return () => clearInterval(countdown);
    }, [minutes, seconds]);

    return (
        <div className='page'>
            <DivHorizental style={{ width: '100%' }}>
                <input id='email' style={{ width: '100%' }}
                    placeholder='가입하신 이메일 계정을 입력하세요'
                    value={Email}
                    onChange={evnt => setEmail(evnt.currentTarget.value)} />
                <Button onClick={evt => {
                    Axios.post('/api/user/forgot_password', { email: Email }).then(response => {
                        if (response.data.success) {
                            alert('입력하신 이메일로 인증번호가 전송되었습니다. 메일을 확인하여 인증번호를 입력해주세요.');
                            setMinutes(5);
                            setSeconds(0);
                        }
                        else {
                            alert(response.data.message);
                        }
                    }).catch(err => alert(err.response.data.message));
                }}>인증번호 전송</Button>
            </DivHorizental>
            {minutes && <>
                이메일로 전송된 인증번호를 입력해주세요.
                <DivHorizental style={{ width: '100%' }}>
                    <input id='authNum' style={{ width: '100%', marginRight: '10px' }}
                        placeholder='인증번호 입력'
                        value={AuthNum}
                        onChange={evnt => setAuthNum(evnt.currentTarget.value)} />
                    <p>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</p>
                </DivHorizental>
                <BtnFullWidthMargined type='primary' onClick={evt => {
                    //로그인
                    dispatch(loginUser({ email: Email, authNum: AuthNum }))
                        .then(response => {
                            if (response.payload.loginSuccess) {
                                window.localStorage.setItem('email', Email);
                                props.history.push("/");
                                alert("인증되었습니다. 회원정보 수정 페이지에서 비밀번호를 수정해주세요.");
                            }
                            else {
                                alert(response.payload.message);
                            }
                        })
                        .catch(err => {
                            alert(err.response.message);
                        });
                }}>인증번호 제출</BtnFullWidthMargined>
            </>}
        </div>
    );
}

export default ForgotPasswordPage;